export default {
    md: 768,
    lg: 1180,
    xl: 1440
};
